<template>
  <div>
    <b-button
      class="brand-icon text-center p-0 h-25 mb-2 text-color"
      variant="outline-secondary"
      block
      @click="checkData"
      :disabled="paymentBntDisabled || state.system.isOffline"
      id="pay-method-pinelab"
    >
      <img
        v-if="state.system.theme == 'theme-light'"
        src="@/assets/images/pinelabs_light.png"
        width="100px"
      />
      <img
        v-if="state.system.theme == 'theme-dark'"
        src="@/assets/images/pinelabs_dark.png"
        width="100px"
      />
    </b-button>
    <!-- <b-button
      class="text-center btn bg-black p-0 h-25 mb-3"
      variant="bg-black"
      block
      style="color: black;"
      @click="openOfflineModal"
      :disabled="paymentBntDisabled"
      v-if="!getStatusType"
    >Pine Labs</b-button>-->
    <!-- <b-button @click="$refs['existing-transaction'].show()">Open</b-button> -->

    <b-modal
      ref="offline-method"
      title="Pay by Pine Labs"
      size="sm"
      centered
      hide-footer
      :hide-header="$loading == true"
      no-close-on-backdrop
      no-close-on-esc
    >
      <b-form @submit.prevent v-if="$loading == false">
        <b-form-group
          id="pinelab-form-group-amt"
          label="Customer Paid"
          label-for="input-1"
        >
          <input
            id="amount-pinelab"
            size="sm"
            class="form-control"
            v-model="amount"
            readonly
          />
        </b-form-group>
        <b-form-group
          class="pay"
          id="pinelab-form-group-trxn"
          label="Enter reference number"
          label-for="input-2"
        >
          <b-form-input
            id="pinelab-input-trxn"
            type="text"
            size="sm"
            autocomplete="off"
            placeholder="Enter reference number"
            v-model="offline_trxn_id"
          ></b-form-input>
        </b-form-group>

        <b-button
          variant="success"
          type="submit"
          class="float-right"
          @click="makePaymentOffline"
          id="pinelab-cont"
        >
          <span v-if="$loading == false">Continue</span>
          <b-spinner small v-if="$loading == true"></b-spinner>
        </b-button>
      </b-form>
      <div v-if="$loading == true" class="m-1">
        <h6 style="font-weight: normal">Processing Payment</h6>
        <b-progress
          :value="100"
          variant="primary"
          striped
          animated
          class="mt-3"
        ></b-progress>
      </div>
    </b-modal>

    <b-modal
      ref="payment-process"
      size="md"
      centered
      id="pay"
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
      hide-header
    >
      <p class="fs-14 d-flex title">
        <img
          v-if="$loading == false"
          src="../assets/images/icon_notif.svg"
          alt
          class="mr-2"
        /><b>Processing Payment</b>
      </p>
      <div v-if="$loading == true" class="m-1">
        <b-progress
          :value="100"
          variant="primary"
          striped
          animated
          class="mt-3"
        ></b-progress>
      </div>
      <div v-if="$loading == false">
        <p class="mt-3">Continue the transaction on the Pine Labs device.</p>
        <p class="">
          <strong>Note:</strong> If you wish to cancel the current transaction,
          close the window from the device and wait for 2 minutes before
          cancelling it.
        </p>
        <div class="d-flex justify-content-end mt-4">
          <b-button
            class="mr-1 mt-2"
            variant="danger"
            block
            @click="cancelRequest"
            id="pinelab-cancel-transaction"
          >
            <span v-if="$loading == false">Cancel Transaction</span>
            <b-spinner small v-if="$loading == true"></b-spinner>
          </b-button>
          <b-button
            variant="primary"
            class="ml-1  mt-2"
            block
            @click="getStatus"
            id="pinelab-get-status"
          >
            <span v-if="$loading == false">Get Status</span>
            <b-spinner small v-if="$loading == true"></b-spinner>
          </b-button>
        </div>
      </div>
    </b-modal>
    <b-modal
      ref="existing-transaction"
      size="sm"
      centered
      id="existing-transaction"
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
      hide-header
    >
      <div>
        <h6 style="font-weight: normal">
          <span class="text-danger">
            <font-awesome-icon :icon="['fa', 'exclamation-circle']" />
          </span>
          Existing Transaction
        </h6>
        <p>
          A transaction is already in progress, Please cancel the previous
          transaction and then try again.
        </p>
        <b-row>
          <b-col md="12" class="text-right">
            <b-button
              class="mt-1"
              variant="primary"
              id="pine-cancel-trxn"
              @click="cancelLastRequest"
            >
              <span v-if="$loading == false">Cancel Transaction</span>
              <b-spinner small v-if="$loading == true"></b-spinner>
            </b-button>
          </b-col>
        </b-row>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapState } from "vuex";
import axios from "axios";

export default {
  name: "pinelabs",
  props: {
    amount: String,
  },
  computed: {
    ...mapState({
      state: (state) => state,
    }),
    checkLayByAmt() {
      let layByAmt = this.state.billing.billing.layBy_Amt;
      if (this.state.billing.billing.layBy_Amt > 0) {
        if (this.state.billing.billing.order.data != "") {
          if (
            this.state.billing.billing.order.summary.amount_due != "0" &&
            this.state.billing.billing.order.data.transaction_sub_type ==
              "sales"
          ) {
            layByAmt = "";
          } else if (
            this.state.billing.billing.total_payable !=
              this.state.billing.billing.layBy_Amt &&
            this.state.billing.billing.order.data.transaction_sub_type ==
              "lay_by"
          ) {
            layByAmt = "";
          }
        }
      }
      return layByAmt;
    },
    paymentBntDisabled() {
      let check = false;
      if (parseFloat(this.amount) > this.state.billing.billing.total_payable) {
        check = true;
      } else if (parseInt(this.amount) <= 0) {
        check = true;
      } else if (this.amount == "") {
        check = true;
      }
      return check;
    },
    getStatusType() {
      let status = false;
      this.state.system.settings.payment_type.map((item) => {
        if (item.mop_name == "pinelab_internal" && item.type == "ONLINE") {
          status = true;
        }
      });
      return status;
    },
    getOrderIdLength() {
      let length = this.state.system.settings.vendor_app_menu.offline
        .offline_invoice_id_format.order_id.name.length;
      return length;
    },
    isOfflineEnabled() {
      let check = false;
      if (
        this.state.system.settings.vendor_app_menu.hasOwnProperty("offline") &&
        this.state.system.settings.vendor_app_menu.offline.status == 1 &&
        this.state.system.isOffline == false
      ) {
        check = true;
      }
      return check;
    },
  },
  data() {
    return {
      trxn_details: "",
      count: 1,
      offline_trxn_id: "",
      pending_pay_id: "",
    };
  },

  methods: {
    checkData() {
      if (this.state.system.settings.hasOwnProperty("pine_lab")) {
        if (
          this.state.system.settings.pine_lab.MerchantID != "" &&
          this.state.system.settings.pine_lab.SecurityToken != "" &&
          this.state.system.settings.pine_lab.IMEI != "" &&
          this.state.system.settings.pine_lab.MerchantStorePosCode != ""
        ) {
          this.sendRequest();
        }
      } else {
        let alertData = {
          message: "Please update device details before continuing",
          type: "danger",
        };
        this.$showAlert = true;
        this.$store.commit("notifications/showAlert", alertData);
      }
    },
    openOfflineModal() {
      this.$refs["offline-method"].show();
    },
    sendRequest() {
      this.$loading = true;
      this.$refs["payment-process"].show();
      let data = {
        TransactionNumber: this.state.billing.billing.order.data.order_id,
        SequenceNumber: this.count,
        AllowedPaymentMode: "1",
        MerchantStorePosCode: this.state.system.settings.pine_lab
          .MerchantStorePosCode,
        Amount: parseFloat(this.amount) * 100,
        UserID: this.state.sessions.user.id,
        MerchantID: this.state.system.settings.pine_lab.MerchantID,
        SecurityToken: this.state.system.settings.pine_lab.SecurityToken,
        IMEI: this.state.system.settings.pine_lab.IMEI,
        AutoCancelDurationInMinutes: "1",
      };
      axios
        .post("/payment-integration/pinelab-upload-bill", data)
        .then((response) => {
          this.$loading = false;
          if (
            response.data.data.ResponseCode == 1 &&
            response.data.data.ResponseMessage == "DB OPERATION FAILED" &&
            response.data.data.PlutusTransactionReferenceID == -1
          ) {
            // console.log(response.data.data.ResponseMessage);
            console.log("Trxn failed try again");
            this.$refs["payment-process"].hide();
            this.makePayment(response.data.data, "fail");
          } else if (
            response.data.data.ResponseCode == 1 &&
            response.data.data.ResponseMessage ==
              "PLEASE APPROVE OPEN TXN FIRST" &&
            response.data.data.PlutusTransactionReferenceID == 0
          ) {
            this.trxn_details = response.data.data;
            // console.log(this.trxn_details);
            this.$refs["payment-process"].hide();
            this.$refs["existing-transaction"].show();
            console.log(
              "A trxn is already opened, please cancel it before continuing."
            );
          } else if (
            response.data.data.ResponseCode == 1 &&
            response.data.data.ResponseMessage ==
              "TXN WITH SIMILAR PARAMS IS ALREADY IN PROGRESS" &&
            response.data.data.PlutusTransactionReferenceID == -5
          ) {
            this.$refs["payment-process"].hide();
            this.$refs["existing-transaction"].show();
            console.log(
              "A trxn is already opened, please cancel it before continuing."
            );
          } else if (
            response.data.data.ResponseCode == "1" &&
            response.data.data.ResponseMessage == "INVALID INPUT"
          ) {
            this.$refs["payment-process"].hide();
          } else if (
            response.data.data.ResponseCode == 0 &&
            response.data.data.ResponseMessage == "APPROVED"
          ) {
            this.count += 1;
            this.trxn_details = response.data.data;
            this.makePayment(response.data.data, "pending");
            // console.log(response.data);
            // setTimeout(() => this.getStatus(), 15000);
            // this.getStatus();
          } else if (
            response.data.data.ResponseCode == 1 &&
            response.data.data.ResponseMessage == "IP IS BLACKLISTED"
          ) {
            this.$refs["payment-process"].hide();
          } else {
            // console.log(response);
          }
          let alertData = {
            message: response.data.data.ResponseMessage,
            type: response.data.data.ResponseCode == 0 ? "success" : "danger",
          };
          this.$showAlert = true;
          this.$store.commit("notifications/showAlert", alertData);
        })
        .catch(() => {
          this.$loading = false;
        });
    },
    cancelRequest() {
      this.$loading = true;
      let data = {
        MerchantID: this.state.system.settings.pine_lab.MerchantID,
        SecurityToken: this.state.system.settings.pine_lab.SecurityToken,
        IMEI: this.state.system.settings.pine_lab.IMEI,
        MerchantStorePosCode: this.state.system.settings.pine_lab
          .MerchantStorePosCode,
        PlutusTransactionReferenceID: this.trxn_details
          .PlutusTransactionReferenceID,
        Amount: parseFloat(this.amount) * 100,
      };
      axios
        .post("/payment-integration/pinelab-cancel-transaction", data)
        .then((response) => {
          this.$loading = false;
          if (
            response.data.data.ResponseCode == 0 &&
            response.data.data.ResponseMessage == "APPROVED"
          ) {
            console.log("trxn cancelled successfully");
            this.$refs["existing-transaction"].hide();
            this.$refs["payment-process"].hide();
            let alertData = {
              message:
                response.data.data.ResponseCode == 0
                  ? "Transaction cancelled successfully!"
                  : response.data.data.ResponseMessage,
              type: response.data.data.ResponseCode == 0 ? "success" : "danger",
            };
            this.$showAlert = true;
            this.$store.commit("notifications/showAlert", alertData);
          } else if (
            response.data.data.ResponseCode == 1 &&
            response.data.data.ResponseMessage == "TRANSACTION NOT FOUND"
          ) {
            this.$refs["existing-transaction"].hide();
            this.$refs["payment-process"].hide();
            let alertData = {
              message: response.data.data.ResponseMessage,
              type: response.data.data.ResponseCode == 0 ? "success" : "danger",
            };
            this.$showAlert = true;
            this.$store.commit("notifications/showAlert", alertData);
          } else {
            // console.log(response.data.data.ResponseMessage);
            let alertData = {
              message: response.data.data.ResponseMessage,
              type: response.data.data.ResponseCode == 0 ? "success" : "danger",
            };
            this.$showAlert = true;
            this.$store.commit("notifications/showAlert", alertData);
          }
        })
        .catch(() => {
          this.$loading = false;
        });
    },
    cancelLastRequest() {
      this.$loading = true;
      let amount = "";
      let ptrn = "";
      this.trxn_details.AdditionalInfo.map((item) => {
        if (item.Tag == "Amount") {
          amount = item.Value;
        }
        if (item.Tag == "ExistingReferenceId") {
          ptrn = item.Value;
        }
      });
      let data = {
        MerchantID: this.state.system.settings.pine_lab.MerchantID,
        SecurityToken: this.state.system.settings.pine_lab.SecurityToken,
        IMEI: this.state.system.settings.pine_lab.IMEI,
        MerchantStorePosCode: this.state.system.settings.pine_lab
          .MerchantStorePosCode,
        PlutusTransactionReferenceID: ptrn,
        Amount: amount,
      };
      axios
        .post("/payment-integration/pinelab-cancel-transaction", data)
        .then((response) => {
          this.$loading = false;
          if (
            response.data.data.ResponseCode == 0 &&
            response.data.data.ResponseMessage == "APPROVED"
          ) {
            console.log("trxn cancelled successfully");
            this.$refs["existing-transaction"].hide();
            this.$refs["payment-process"].hide();
            let alertData = {
              message:
                response.data.data.ResponseCode == 0
                  ? "Transaction cancelled successfully!"
                  : response.data.data.ResponseMessage,
              type: response.data.data.ResponseCode == 0 ? "success" : "danger",
            };
            this.$showAlert = true;
            this.$store.commit("notifications/showAlert", alertData);
          } else if (
            response.data.data.ResponseCode == 1 &&
            response.data.data.ResponseMessage == "TRANSACTION NOT FOUND"
          ) {
            this.$refs["existing-transaction"].hide();
            this.$refs["payment-process"].hide();
            let alertData = {
              message: response.data.data.ResponseMessage,
              type: response.data.data.ResponseCode == 0 ? "success" : "danger",
            };
            this.$showAlert = true;
            this.$store.commit("notifications/showAlert", alertData);
          } else {
            // console.log(response.data.data.ResponseMessage);
            let alertData = {
              message: response.data.data.ResponseMessage,
              type: response.data.data.ResponseCode == 0 ? "success" : "danger",
            };
            this.$showAlert = true;
            this.$store.commit("notifications/showAlert", alertData);
          }
        })
        .catch(() => {
          this.$loading = false;
        });
    },
    getStatus() {
      // this.$loading = true;
      let data = {
        MerchantID: this.state.system.settings.pine_lab.MerchantID,
        SecurityToken: this.state.system.settings.pine_lab.SecurityToken,
        IMEI: this.state.system.settings.pine_lab.IMEI,
        MerchantStorePosCode: this.state.system.settings.pine_lab
          .MerchantStorePosCode,
        PlutusTransactionReferenceID: this.trxn_details
          .PlutusTransactionReferenceID,
      };
      axios
        .post("/payment-integration/pinelab-get-status", data)
        .then((response) => {
          // this.$loading = false;
          // console.log(response.data.data);
          if (
            (response.data.data.ResponseCode == 1 &&
              response.data.data.ResponseMessage ==
                "INVALID PLUTUS TXN REF ID") ||
            (response.data.data.ResponseCode == 1 &&
              response.data.data.ResponseMessage ==
                "INVALID TRANSACTION NUMBER")
          ) {
            this.$refs["payment-process"].hide();
            this.makePayment(response.data.data, "fail");
            console.log("Trxn is cancelled.");
          } else if (
            response.data.data.ResponseCode == 1001 &&
            response.data.data.ResponseMessage == "TXN UPLOADED"
          ) {
            // setTimeout(() => this.getStatus(), 15000);
            console.log("Trxn Processing.");
          } else if (
            response.data.data.ResponseCode == 0 &&
            response.data.data.ResponseMessage == "TXN APPROVED"
          ) {
            console.log("Trxn Approved");
            this.makePayment(response.data.data, "success");
          }
          let alertData = {
            message: response.data.data.ResponseMessage,
            type: response.data.data.ResponseCode == 0 ? "success" : "danger",
          };
          this.$showAlert = true;
          this.$store.commit("notifications/showAlert", alertData);
        })
        .catch(() => {
          this.$loading = false;
        });
    },
    makePayment(res, status) {
      this.$loading = true;

      let order_id = "";
      if (this.isOfflineEnabled && status != "pending") {
        order_id = this.state.billing.billing.invoice_no;
        console.log(order_id);
        order_id = order_id.substring(order_id.length - this.getOrderIdLength);
      }

      let postData = {
        amount: this.amount,
        t_order_id: "",
        order_id: this.state.billing.billing.order.data.order_id,
        pay_id: status == "pending" ? "" : res.PlutusTransactionReferenceID,
        payment_initiate_id:
          status == "pending" ? res.PlutusTransactionReferenceID : "",
        payment_id: status == "success" ? this.pending_pay_id : "",
        method: "card",
        invoice_id: "",
        bank: "",
        wallet: "",
        vpa: "",
        error_description: "",
        status:
          status == "fail"
            ? "error"
            : status == "pending"
            ? "pending"
            : "success",
        address_id: "",
        payment_gateway_type: "PINELAB_INTERNAL",
        cash_collected: "",
        cash_return: "",
        lay_by_total: this.checkLayByAmt,
        lay_by_remark: "",
        transaction_sub_type:
          this.state.billing.billing.layBy_Amt != 0 ? "lay_by" : "",
        url: "save-payment",
        gateway_response: status == "pending" ? "" : JSON.stringify(res),
        payment_gateway_device_type: "",
        invoice_seq: order_id,
        remark: this.state.billing.billing.remark,
      };
      // let insertData = {
      //   order_id: "",
      //   invoice_id: this.state.billing.billing.invoice_no,
      //   type: "online",
      //   v_id: parseInt(this.state.sessions.user.v_id),
      //   store_id: parseInt(this.state.sessions.user.store_id),
      //   vu_id: parseInt(this.state.sessions.user.vu_id),
      //   date: moment(new Date()).format("YYYY-MM-DD"),
      //   time: moment(new Date()).format("HH:mm:ss")
      // };
      let data = Object.assign(
        postData,
        this.essentialsData,
        this.customerData
      );
      this.$store
        .dispatch("billing/savePayment", data)
        .then((res) => {
          if (status == "pending") {
            // console.log(res.data.data.payment_id);
            this.pending_pay_id = res.data.data.payment_id;
          } else {
            this.$refs["payment-process"].hide();
          }
          this.$loading = false;
          if (
            this.state.billing.billing.total_payable == 0 ||
            this.state.billing.billing.total_payable == "0.00"
          ) {
            if (this.isOfflineEnabled) {
              this.$store.dispatch("billing/saveInvoiceId");
            }

            this.$store.commit("billing/resetBilling");
          }
          if (res.data.status == "validation") {
            let alertData = {
              message: res.data.message,
              type: "danger",
            };
            this.$showAlert = true;
            this.$store.commit("notifications/showAlert", alertData);
          }
        })
        .catch(() => {
          this.$loading = false;
        });
    },
    makePaymentOffline() {
      this.$loading = true;

      let order_id = "";
      if (this.isOfflineEnabled) {
        order_id = this.state.billing.billing.invoice_no;
        console.log(order_id);
        order_id = order_id.substring(order_id.length - this.getOrderIdLength);
      }

      let postData = {
        amount: this.amount,
        t_order_id: "",
        order_id: this.state.billing.billing.order.data.order_id,
        pay_id: this.offline_trxn_id,
        method: "card",
        invoice_id: "",
        bank: "",
        wallet: "",
        vpa: "",
        error_description: "",
        status: "success",
        address_id: "",
        payment_gateway_type: "PINELAB_INTERNAL",
        cash_collected: "",
        cash_return: "",
        lay_by_total: this.checkLayByAmt,
        lay_by_remark: "",
        transaction_sub_type:
          this.state.billing.billing.layBy_Amt != 0 ? "lay_by" : "",
        url: "save-payment",
        gateway_response: "",
        payment_gateway_device_type: "",
        invoice_seq: order_id,
        remark: this.state.billing.billing.remark,
      };
      // let insertData = {
      //   order_id: "",
      //   invoice_id: this.state.billing.billing.invoice_no,
      //   type: "online",
      //   v_id: parseInt(this.state.sessions.user.v_id),
      //   store_id: parseInt(this.state.sessions.user.store_id),
      //   vu_id: parseInt(this.state.sessions.user.vu_id),
      //   date: moment(new Date()).format("YYYY-MM-DD"),
      //   time: moment(new Date()).format("HH:mm:ss"),
      // };
      let data = Object.assign(
        postData,
        this.essentialsData,
        this.customerData
      );
      this.$store
        .dispatch("billing/savePayment", data)
        .then((res) => {
          this.$loading = false;
          if (
            this.state.billing.billing.total_payable == 0 ||
            this.state.billing.billing.total_payable == "0.00"
          ) {
            if (this.isOfflineEnabled) {
              this.$store.dispatch("billing/saveInvoiceId");
            }
            this.$store.commit("billing/resetBilling");
          }
          if (res.data.status == "validation") {
            let alertData = {
              message: res.data.message,
              type: "danger",
            };
            this.$showAlert = true;
            this.$store.commit("notifications/showAlert", alertData);
          }
          this.$refs["payment-process"].hide();
        })
        .catch(() => {
          this.$loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.bg-black {
  background-color: #000;
  border: 1px #606060 solid;
  color: #fff;
}
.theme-light .bg-black {
  background-color: transparent;
  border: 1px #c0c0c0 solid;
  color: #404040;
}
.py-2 {
  padding-bottom: 0.8rem !important;
  padding-top: 0.8rem !important;
}
.h-25 {
  height: 40px !important;
}
.theme-dark .text-color {
  color: #c0c0c0 !important;
}
.theme-light .text-color {
  color: black !important;
}
.brand-icon:hover img {
  opacity: 0.5;
}
</style>
